import React from "react";
import Modal from "../common/Modal/Modal";
import { formatDateTimeToZone } from "../common/Helpers";

// Shows the invoice's event log (sent/approved/rejected/paid, etc.) in a popup,
// same underlying data the inline "History" panel used to show.
export default function InvoiceHistoryModal(props) {

    const orderedHistory = props.orderedHistory || [];

    return (
        <Modal className="extra-wide" blurBack={true} hideLogo={true} hasCloseButton={true} handleClose={() => props.setHistoryModalOpen(false)} >
            <div className="modal-content">
                <h1 className="title heavy gap-below-m">History</h1>
                {orderedHistory.length > 0
                ? orderedHistory.map((item) => {
                    return (
                        <div key={item.event_date} className="gap-below-m">
                            <h4 className="content1 heavy multiline">{item.event}<span className="light">&nbsp;&nbsp;&nbsp;{formatDateTimeToZone(item.event_date)}</span> </h4>
                            <h5 className="content1 light-black multiline" >by {item.first_name} {item.last_name}</h5>
                            {item.comments &&
                                <h6 className="content2 light-black multiline gap-above-xs" style={{ whiteSpace: "break-spaces" }}>"{item.comments}"</h6>
                            }
                        </div>
                    )
                })
                : <p className="content1 light-black">No history to show yet.</p>}
            </div>
        </Modal>
    );
}
